import { toast } from 'react-toastify'
const bgImage1 = 'https://res.cloudinary.com/artieve-test/image/upload/v1762373920/greenfieldsposter_z3lwq5.svg'
const bgImage2 = 'https://res.cloudinary.com/artieve-test/image/upload/v1762373920/greenhillsposter_syp9ts.svg'

const PromptCard = ({ title, body, time, index, isUsedToday, onClick }) => {
    const bgImages = [bgImage1, bgImage2]
    const bgImage = bgImages[index % bgImages.length]

    const usedPromptAlert = () => {
        toast.info("You've already created artwork with this prompt today!")
    }

    return (
        <article 
            className={`prompt-card ${isUsedToday ? 'used' : ''}`} 
            onClick={isUsedToday ? usedPromptAlert : onClick}
        >
            <img src={bgImage} alt="illustration of green hills and fields" />
            <aside>
                <h3>{title}</h3>
                <p>{body}</p>
                <p>{time}</p>
            </aside>
        </article>
    )
}

export default PromptCard